import { defineMessages } from 'react-intl';

export default defineMessages({
  corporateReference: {
    id: 'corporateInfo.corporateReference',
    defaultMessage: 'Trainline Corporate Reference',
  },
  clientReference: {
    id: 'corporateInfo.clientReference',
    defaultMessage: 'Client Reference',
  },
});
